
export type AllCriteria = {
    $type: "All"
}

export type AndCriteria = {
    $type: "And"
    criteria: Criteria[]
}

export type OrCriteria = {
    $type: "Or"
    criteria: Criteria[]
}

export type EqualCriteria<T> = {
    $type: "Equal"
    attr: string
    value: T
}

export type NotCriteria = {
    $type: "Not"
    criteria: Criteria
}

export type NotEqualCriteria<T> = {
    $type: "NotEqual"
    attr: string
    value: T
}

export type GreaterCriteria = {
    $type: "Greater"
    attr: string
    value: any
}

export type GreaterEqualCriteria = {
    $type: "GreaterEqual"
    attr: string
    value: number
}

export type LessCriteria = {
    $type: "Less"
    attr: string
    value: number
}

export type LessEqualCriteria = {
    $type: "LessEqual"
    attr: string
    value: number
}

export type DateGreaterCriteria = {
    $type: "DateGreater"
    attr: string
    value: any
}

export type DateGreaterEqualCriteria = {
    $type: "DateGreaterEqual"
    attr: string
    value: number
}

export type DateLessCriteria = {
    $type: "DateLess"
    attr: string
    value: number
}

export type DateLessEqualCriteria = {
    $type: "DateLessEqual"
    attr: string
    value: number
}

export type InCriteria<T> = {
    $type: "In"
    attr: string
    values: T[]
}

export type LikeCriteria = {
    $type: "Like"
    attr: string
    value: any
}

export type InteractsCriteria = {
    $type: "Interacts"
    geoShapeKey: string,
    layerViewId: number | undefined,
    featureId: number | undefined,
    name: string
} | {
    $type: "Interacts"
    geometry: any
}

export type NearestCriteria = {
    $type: "Nearest",
    name: string
    numNeighbours: number
    distance: number
    unit: "KILOMETER" | "FOOT" | "MILE" | "SURVEY_FOOT"
    geometry: any
} | {
    $type: "Nearest",
    name: string
    numNeighbours: number
    distance: number
    unit: "KILOMETER" | "FOOT" | "MILE" | "SURVEY_FOOT"
    geoShapeKey: string
}

export type NoneCriteria = {
    $type: "None"
}

export type TerritoryLevelCriteria = {
    $type: "TerritoryLevel"
    level: number
    parent: number | null
}

export type WithinDistanceCriteria = {
    $type: "WithinDistance"
    name: string
    distance: number
    unit: "KILOMETER" | "FOOT" | "MILE" | "SURVEY_FOOT"
    geoShapeKey?: string
    geometry?: any
}

const nonAttributeCriteria: Criteria["$type"][] = ["WithinDistance", "Interacts", "All", "None", "Interacts", "Nearest"]

export function getRequiredAttributes(criteria: Criteria|undefined|null): string[] {
    if(!criteria) {
        return []
    }

    if(criteria.$type === "Or" || criteria.$type === "And"){
        return criteria.criteria.flatMap(getRequiredAttributes);
    }

    if(criteria.$type === "Not") {
        return getRequiredAttributes(criteria.criteria);
    }

    if(nonAttributeCriteria.includes(criteria.$type)) {
        return [];
    }

    if(criteria.$type === "TerritoryLevel") {
        return ["ES_LEVEL", "ES_PARENT_ID"];
    }

    return [criteria?.attr];
}

export type Criteria = AllCriteria | AndCriteria | OrCriteria | EqualCriteria<any> | NotCriteria |
    NotEqualCriteria<any> | GreaterCriteria | GreaterEqualCriteria | LessCriteria | LessEqualCriteria |
    DateGreaterCriteria | DateGreaterEqualCriteria | DateLessCriteria | DateLessEqualCriteria |
    InCriteria<any> | LikeCriteria | InteractsCriteria | NearestCriteria | NoneCriteria |
    TerritoryLevelCriteria | WithinDistanceCriteria
